
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as LightningIconComponent } from "./lightning-icon.svg";

export const LightningIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <LightningIconComponent {...props} />;
};
